/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable indent */
/* eslint-disable complexity */
import BulletListIcon from "@atlaskit/icon/glyph/bullet-list";
import EditorWarningIcon from "@atlaskit/icon/glyph/editor/warning";
import PersonIcon from "@atlaskit/icon/glyph/person";
import EmojiFrequentIcon from "@atlaskit/icon/glyph/emoji/frequent";
import SignOutIcon from "@atlaskit/icon/glyph/sign-out";
import ExportIcon from "@atlaskit/icon/glyph/export";
import ArrowUpCircleIcon from "@atlaskit/icon/glyph/arrow-up-circle";
import ScheduleIcon from "@atlaskit/icon/glyph/schedule";
import {
    ButtonItem,
    NavigationContent,
    NavigationHeader,
    Section,
    SideNavigation,
} from "@atlaskit/side-navigation";
import { useContext, useState, useEffect } from "react";
import {
    Redirect,
    Route,
    Switch,
    useHistory,
    useLocation,
    useRouteMatch,
} from "react-router-dom";
import { AuthContext } from "../../contexts/Auth/AuthContext";
import Appointments from "../Appointments/Appointments";
import { Blockers } from "../Blockers/Blockers";
import UserDetails from "../UserDetails/UserDetails";
import WorkingTimeSlots from "../WorkingTimeSlots/WorkingTimeSlots";
import "./Navigation.scss";
import Export from "../Export/Export";
import Profile from "../Profile/Profile";
import AddTestUsers from "../AddTestUsers/AddTestUsers";
import AddAppointment from "../AddAppointment/AddAppointment";
import RoomMenuIcon from "@atlaskit/icon/glyph/room-menu";
import PeopleIcon from '@atlaskit/icon/glyph/people'
import TrashIcon from "@atlaskit/icon/glyph/trash";
import { GenerateVouchers } from "../GenerateVouchers/GenerateVouchers";
import { PriorityList } from "../PriorityList/PriorityList";
import DeleteUserAccount from "../DeleteUserAccount/DeleteUserAccount";
const Navigation = () => {
    const authContext = useContext(AuthContext);
    const history = useHistory();
    const match = useRouteMatch<{ [key: string]: string }>();
    const location = useLocation();
    const [selected, setSelected] = useState(
        location.pathname.split("/")[location.pathname.split("/").length - 1]
    );

    useEffect(() => {
        setSelected(
            location.pathname.split("/")[
            location.pathname.split("/").length - 1
            ]
        );
    }, [location.pathname]);

    const isSelected = (item: string): boolean => item === selected;

    interface RouteProps {
        permission: boolean;
        component: any;
        path: string;
    }

    const ProtectedRoute = ({ permission, component, path }: RouteProps): any =>
        permission ? <Route path={path} component={component} /> : null;

    return (
        <div className="app">
            <div className="app-sidebar">
                <SideNavigation label="project" testId="side-navigation">
                    <NavigationHeader>
                        <div className="mamly-logo-container">
                            <img
                                className="mamly-logo"
                                src="/mamly_icon.png"
                                alt="logo"
                            />
                            <div className="mamly-text-container">
                                <div className="mamly-text-mamly">MAMLY</div>
                                <div className="mamly-text-love-yourself">
                                    LOVE YOURSELF
                                </div>
                            </div>
                        </div>
                    </NavigationHeader>
                    <NavigationContent>
                        <Section>
                            <ButtonItem
                                onClick={() => {
                                    setSelected("appointments");
                                    history.push(`${match?.url || '/home'}/appointments`);
                                }}
                                isSelected={isSelected("appointments")}
                                iconBefore={<BulletListIcon label="" />}
                            >
                                Termine
                            </ButtonItem>
                            <ButtonItem
                                onClick={() => {
                                    setSelected("working_time_slots");
                                    history.push(
                                        `${match?.url || '/home'}/working_time_slots`
                                    );
                                }}
                                isSelected={isSelected("working_time_slots")}
                                iconBefore={<EmojiFrequentIcon label="" />}
                            >
                                Arbeitszeiten
                            </ButtonItem>
                            <ButtonItem
                                onClick={() => {
                                    setSelected("blockers");
                                    history.push("/home/blockers");
                                }}
                                isSelected={isSelected("blockers")}
                                iconBefore={<EditorWarningIcon label="" />}
                            >
                                Blocker
                            </ButtonItem>

                            <ButtonItem
                                onClick={() => {
                                    setSelected("profile");
                                    history.push("/home/profile");
                                }}
                                isSelected={isSelected("profile")}
                                iconBefore={<PersonIcon label="" />}
                            >
                                Profile
                            </ButtonItem>
                            <ButtonItem
                                onClick={() => {
                                    setSelected("addAppointment");
                                    history.push("/home/addAppointment");
                                }}
                                isSelected={isSelected("addAppointment")}
                                iconBefore={<ScheduleIcon label="" />}
                            >
                                Termin mit Benutzer hinzufügen
                            </ButtonItem>

                            {authContext.InsuranceExportPermission && (
                                <ButtonItem
                                    onClick={() => {
                                        setSelected("export");
                                        history.push("/home/export");
                                    }}
                                    isSelected={isSelected("export")}
                                    iconBefore={<ExportIcon label="" />}
                                >
                                    Export insurance data
                                </ButtonItem>
                            )}
                            {authContext.CreateTesterPermission && (
                                <ButtonItem
                                    onClick={() => {
                                        setSelected("testUsers");
                                        history.push("/home/testUsers");
                                    }}
                                    isSelected={isSelected("testUsers")}
                                    iconBefore={<ArrowUpCircleIcon label="" />}
                                >
                                    Testbenutzer hinzufügen
                                </ButtonItem>
                            )}
                            {authContext.GenerateVouchersPermission && (
                                <ButtonItem
                                    onClick={() => {
                                        setSelected("generateVouchers");
                                        history.push("/home/generateVouchers");
                                    }}
                                    isSelected={isSelected("generateVouchers")}
                                    iconBefore={<RoomMenuIcon label="" />}
                                >
                                    Voucher generieren
                                </ButtonItem>
                            )}
                            {authContext.AssignPriorityPermission && (
                                <ButtonItem
                                    onClick={() => {
                                        setSelected("priorityList");
                                        history.push("/home/priorityList");
                                    }}
                                    isSelected={isSelected("priorityList")}
                                    iconBefore={<PeopleIcon label="" />}
                                >
                                    Prioritäten Liste
                                </ButtonItem>
                            )}
                            {authContext.DeleteUsersPermission && (
                                <ButtonItem
                                    onClick={() => {
                                        setSelected("deleteUser");
                                        history.push("/home/deleteUser");
                                    }}
                                    isSelected={isSelected("deleteUser")}
                                    iconBefore={<TrashIcon label="" />}
                                >
                                    Nutzer löschen
                                </ButtonItem>
                            )}
                            <ButtonItem
                                onClick={authContext.actions.logout}
                                //  isSelected={isSelected("blockers")}
                                iconBefore={<SignOutIcon label="" />}
                            >
                                Logout
                            </ButtonItem>
                        </Section>
                    </NavigationContent>
                </SideNavigation>
            </div>
            <div className="app-content">
                <Switch>
                    <Route
                        path={"/home/appointments"}
                        component={Appointments}
                    />
                    <Route
                        path="/home/working_time_slots"
                        component={WorkingTimeSlots}
                    />
                    <Route path="/home/blockers" component={Blockers} />
                    <Route path="/home/users/:id" component={UserDetails} />
                    <Route path="/home/profile" component={Profile} />
                    <Route
                        path="/home/addAppointment"
                        component={AddAppointment}
                    />
                    <ProtectedRoute
                        permission={authContext.InsuranceExportPermission}
                        component={Export}
                        path={"/home/export"}
                    />
                    <ProtectedRoute
                        permission={authContext.CreateTesterPermission}
                        component={AddTestUsers}
                        path={"/home/testUsers"}
                    />
                    <ProtectedRoute
                        permission={authContext.GenerateVouchersPermission}
                        component={GenerateVouchers}
                        path={"/home/generateVouchers"}
                    />
                    <ProtectedRoute
                        permission={authContext.AssignPriorityPermission}
                        component={PriorityList}
                        path="/home/priorityList"
                    />
                    <ProtectedRoute
                        permission={authContext.DeleteUsersPermission}
                        component={DeleteUserAccount}
                        path="/home/deleteUser"
                    />
                    <Redirect from="/home" to={"/home/appointments"} />
                </Switch>
            </div>
        </div>
    );
};

export default Navigation;
